/**
 * converts flstatus into color code
 * @param {number} flightstate
 * @returns {String}
 */
export const convertFlightState = (flightstate: number): string => {
  let classStr = "grey";

  switch (flightstate) {
    case 0:
      classStr = "black"; // e.g. Boarding
      break;
    case 1:
      classStr = "green"; // e.g. Gate open
      break;
    case 2:
      classStr = "orange";
      break;
    case 3:
      classStr = "red"; // e.g. Closed
      break;
  }

  return classStr;
};

/**
 * converts flstatus into color code for overview flights
 * @param {number} flightstate
 * @param {string} status
 * @returns {string}
 */
export const convertOverviewFlightState = (flightstate: number, status: string): string => {
  let classStr = "grey";

  const exceptionCases: string[] = [
    "geschlossen",
    "closed",
    "已关闭",
    "gestartet",
    "departed",
    "已起飞",
    "im anflug",
    "approaching",
    "在飞行中",
    "gepäckausgabe erwatet",
    "baggage delivery finished",
    "gepäckausgabe gepäck ist unterwegs",
    "baggage delivery on its way",
    "行李運送途中",
    "gepäckausgabe beendet",
    "baggage delivery finished",
    "托运行李领取已结束",
    "",
  ];

  if (exceptionCases.find(state => state.toLowerCase() === status.toLowerCase())) {
    return classStr;
  }

  if (flightstate === 0 || flightstate === 1) {
    classStr = "green"; // e.g. Gate open, Boarding, gelandet, Gepäckausgabe...
  }
  if (flightstate > 1 && flightstate <= 3) {
    classStr = "red"; // e.g. Annulliert, Umgeleitet, Gepäckausgabe verzögert...
  }

  return classStr;
};
